import { BasePayloadMapper } from '@ps/utils';
import { OperatorActivityLog, SurveyActivityLog } from '@ps/survey-utils';

import {
  OperatorActivityLogPayloadDto,
  SurveyActivityLogPayloadDto,
} from '../survey-activity-log.dto';
import {
  ACTIVITY_LOG_ORIGIN,
  ACTIVITY_LOG_PLATFORM,
} from './activity-log-payload.constants';

export class SurveyActivityLogPayloadMapper extends BasePayloadMapper<
  SurveyActivityLog,
  SurveyActivityLogPayloadDto
> {
  public toPayload(log: SurveyActivityLog): SurveyActivityLogPayloadDto {
    return {
      surveyId: log.surveyId,
      eventSource: log.eventSource ?? 'user',
      logMessage: log.message,
      category: log.category,
      metadata: log.metadata,
      platform: ACTIVITY_LOG_PLATFORM,
      origin: ACTIVITY_LOG_ORIGIN,
    };
  }

  public toOperatorPayload(
    log: OperatorActivityLog,
  ): OperatorActivityLogPayloadDto {
    return {
      logMessage: log.message,
      category: log.category,
      metadata: log.metadata,
      origin: ACTIVITY_LOG_ORIGIN,
    };
  }
}
